import { render } from "./GoldSponsor.vue?vue&type=template&id=277d8304&scoped=true"
import script from "./GoldSponsor.vue?vue&type=script&lang=js"
export * from "./GoldSponsor.vue?vue&type=script&lang=js"

import "./GoldSponsor.vue?vue&type=style&index=0&id=277d8304&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277d8304"]])

export default __exports__